import React from 'react';
import { Trophy, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../supabaseClient';

export const Header: React.FC = () => {
  const { user } = useAuth();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <header className="bg-[#141921] border-b border-[#2d3748]">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Trophy className="text-[#3b82f6]" size={32} />
            <h1 className="text-2xl font-bold text-[#ffffff]">
              Triathlon Trainer
            </h1>
          </div>

          <div className="flex items-center space-x-4">
            {user && (
              <>
                <p className="text-sm text-[#718096]">
                  {user.email}
                </p>
                <button
                  onClick={handleSignOut}
                  className="flex items-center gap-2 px-3 py-1.5 text-sm text-[#718096] hover:text-[#3b82f6] hover:bg-[#141921] rounded-lg transition-colors"
                >
                  <LogOut size={16} />
                  Sign Out
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
